import React, { Component } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import { Default, Mobile } from './ViewTypes';
import moment from 'moment';
import Constants from '../components/Constants'
import { getSelectorsByUserAgent } from 'react-device-detect'
import { canoc } from '../managers/Utils';
class SearchResultItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventData: props.eventData,
    };
  }

  render() {
    const { eventData } = this.state;
    const { isMobile } = getSelectorsByUserAgent(this.props.userAgent);

    return (
      <div style={{cursor: 'pointer'}} onClick={() => this.props.onClick && this.props.onClick()}>
          {isMobile &&  <ListGroup.Item
            style={{
              margin: 5,
              borderColor: 'darkgrey',
              boxShadow: '2px 2px 10px 0px #00000066',
            }}
          >
            <a href={`/event/${canoc(eventData.title, eventData.id)}?aff=eta_search`} style={{color: 'black'}}>
            <div style={{ display: 'block', justifyContent: 'center' }}>
            <div
                style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: '20px',
                  display: 'flex',
                  backgroundImage: `url(${eventData.image_url})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  height: '180px'
                }}
              >
              </div>
              <div style={{ marinTop: '20px' }}>
                <h5 style={{ marginBottom: '1rem' }}>{eventData.title}</h5>
                <p style={{ fontSize: '18px'}}> {moment(eventData.start_date).format('ddd MMM Do, h:mm a')}</p>
                {eventData.cost === 0 ? (
                    <p style={{ fontSize: '14px' }}>Free</p>
                  ) : (
                    <p style={{ fontSize: '14px' }}>{"$" + eventData.cost}</p>
                  )}
              </div>
            </div>
            </a>
          </ListGroup.Item>}

          {!isMobile && <ListGroup.Item
            style={{
              margin: '10px',
              borderColor: 'darkgrey',
              boxShadow: '2px 2px 10px 0px #00000066',
            }}
          >
            <a href={`/event/${canoc(eventData.title, eventData.id)}?aff=eta_search`} style={{color: 'black'}}>
            <div style={{ display: 'flex' }}>
              <div style={{ margin: '10px', display: 'inline-block' }}>
                <a href={`/event/${eventData.id}`}><div
                  style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '20px',
                    display: 'flex',
                    backgroundImage: `url(${eventData.image_url})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '140px',
                    width: '280px'
                  }}
                /></a>
              </div>
              <div
                style={{
                  display: 'inline-block',
                  margin: '10px 10px 10px 40px',
                }}
              >
                <div>
                  <a style={{color: 'black'}} href={`/event/${eventData.id}`}><h5 style={{ marginBottom: '1rem' }}>{eventData.title}</h5></a>
                  <p style={{ fontSize: '18px' }}>
                    {moment(eventData.start_date).format('ddd MMM Do, h:mm a')}
                  </p>
                  {eventData.cost === 0 ? (
                    <p style={{ fontSize: '14px' }}>Free</p>
                  ) : (
                    <p style={{ fontSize: '14px' }}>${eventData.cost}</p>
                  )}
                </div>
              </div>
            </div>
            </a>
          </ListGroup.Item> }
        </div>
    );
  }
}

export default SearchResultItems;
